import { AppointmentResponse } from "@smart/bridge-types-basic";
import { Icon } from "@smart/itops-sb-design-system-dom";
import { displayAppointmentValues } from "@smart/itops-utils-basic";

import { FieldItem } from "../../types";
import {
  AppointmentFieldWrapper,
  getAppointmentDuration,
  getAppointmentTimezoneOptions,
  intakeMeetingTypeLabel,
} from "../field-components";

export const SummaryAppointment = ({
  field,
  response,
}: {
  field: FieldItem;
  response: AppointmentResponse | undefined;
}) => {
  const { bookedStaff, startTime, endTime, timezone, status } = response || {};
  const isValid = status && status !== "invalid" && bookedStaff?.length;
  const date = displayAppointmentValues({
    startTime,
    endTime,
    timezone,
    dayFormat: "dd MMM yyyy",
  });

  return (
    <AppointmentFieldWrapper id="" errorId="" field={field}>
      {isValid ? (
        <div className="flex flex-col gap-large p-[2.4rem] text-ui">
          <div className="flex flex-col gap-xSmall">
            <div className="font-semibold">Selected attendee</div>
            <div>
              {[
                bookedStaff[0].firstName,
                bookedStaff[0].middleName,
                bookedStaff[0].lastName,
              ]
                .filter(Boolean)
                .join(" ")}
            </div>
          </div>
          <div className="flex flex-col gap-medium">
            <div className="flex flex-col gap-xSmall">
              <div className="font-semibold">Timezone</div>
              <div>
                {
                  getAppointmentTimezoneOptions().find(
                    (tz) => tz.tzCode === timezone,
                  )?.label
                }
              </div>
            </div>
            <div className="flex items-center gap-small">
              <Icon name="lightClock" />
              <span className="text-paragraph">
                {getAppointmentDuration(
                  field.duration || 0,
                  field.durationUnit,
                )}
              </span>
            </div>
            <div className="flex items-center gap-small">
              <Icon name="lightMobile" />
              <span className="text-paragraph">
                {intakeMeetingTypeLabel[field.meetingType || "inPerson"]}
              </span>
            </div>
          </div>
          <div className="flex flex-col gap-xSmall">
            <div className="font-semibold">Date</div>
            <div>{date.day}</div>
          </div>
          <div className="flex flex-col gap-xSmall">
            <div className="font-semibold">Time</div>
            <div>{date.startTimeString}</div>
          </div>
        </div>
      ) : (
        <p className="text-ui p-[2.4rem]">No appointment made</p>
      )}
    </AppointmentFieldWrapper>
  );
};
